<template>
  <ImageTextTeasersBlock
    :teasers="mappedTeasers"
    :cols="mappedCols"
    :cols-centered="item.fields.teaserCenteredInRow ?? false"
    :content-centered="item.fields.teaserCentered ?? false"
    :is-image-stretched="item.fields.stretchedImage ?? false"
    :is-rounded="item.fields.roundedImages ?? true"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'teasers'
      })
    "
  />
</template>

<script setup lang="ts">
import { ImageTextTeasersBlock } from '@hypercodestudio/basler-components';
import type { ImageTextTeaserInterface } from '@hypercodestudio/basler-components/dist/components/modules/ImageTextTeaser.vue';
import type { ITextImageTeaserList } from '~/lib/ContentfulService';
import { generateImageObject } from '~/utils/generateImageObject';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { isEntryResolveError } from '~/utils/guards/isEntryResolveError';
import { ContentfulLivePreview } from '@contentful/live-preview';

interface Props {
  item: ITextImageTeaserList;
}

const props = defineProps<Props>();

const imageSize = props.item.fields.imageSize ?? '';

const mappedTeasers = computed(
  () =>
    props.item.fields.teasers
      ?.filter((entry) => !isEntryResolveError(entry))
      ?.map<ImageTextTeaserInterface>((teaser) => ({
        headline: teaser.fields.headline,
        text: teaser.fields.text ?? '',
        image:
          teaser.fields.image &&
          generateImageObject(teaser.fields.image, {
            sizes: imageSize,
            widths: [200, 400],
            keepAspectRatio: true
          })?.content,
        buttonText: teaser.fields.link?.fields?.linkText,
        buttonLink: useBuildLinkInterface(teaser.fields.link),
        buttonStyle: teaser.fields.link?.fields?.linkStyle
      })) ?? []
);

const mappedCols = computed(
  () => mapColsWidth(props.item.fields.teaserWidth) ?? 10
);
</script>
